import React from 'react';
import { Container, Row } from 'reactstrap';

const AppBand = () => {
  return (
    <Container fluid className='app-band'>
      <Container>
        <Row />
      </Container>
    </Container>
  )
}

export default AppBand;
